"use client";

import { Star, Zap, CalendarClock, Sparkles, SprayCan } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const trustPillars = [{
  id: 1,
  iconType: "zap",
  mainText: "",
  subText: "Fast response"
}, {
  id: 2,
  iconType: "calendarClock",
  mainText: "",
  subText: "Reliable scheduling"
}, {
  id: 3,
  iconType: "sparkles",
  mainText: "",
  subText: "Detail‑focused service"
}, {
  id: 4,
  iconType: "sprayCan",
  mainText: "",
  subText: "Professional tools and supplies"
}];
export default function TheVendiTrustPillars() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="101140" id="the-easylocal-standard" className="bg-secondary py-20 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-center text-2xl md:text-3xl font-default text-primary tracking-widest mb-12 md:mb-16 uppercase">
          The EasyLocal Standard
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-16 md:gap-20 text-center">
          {trustPillars.map((pillar, i) => <div key={pillar.id} data-index={i} className="flex flex-col items-center justify-start gap-5">
              <div className="h-16 flex items-center justify-center text-primary">
                {pillar.iconType === "stars" && <div className="flex gap-1">
                    {[...Array(5)].map((_, starIdx) => <Star key={starIdx} data-index={starIdx} className="w-8 h-8 md:w-10 md:h-10 fill-current" />)}
                  </div>}
                {pillar.iconType === "text" && <span className="text-5xl md:text-6xl font-default font-bold tracking-tighter">
                    {pillar.mainText}
                  </span>}
                {pillar.iconType === "zap" && <Zap className="w-12 h-12 md:w-14 md:h-14" strokeWidth={1} />}
                {pillar.iconType === "calendarClock" && <CalendarClock className="w-12 h-12 md:w-14 md:h-14" strokeWidth={1} />}
                {pillar.iconType === "sparkles" && <Sparkles className="w-12 h-12 md:w-14 md:h-14" strokeWidth={1} />}
                {pillar.iconType === "sprayCan" && <SprayCan className="w-12 h-12 md:w-14 md:h-14" strokeWidth={1} />}
              </div>
              <h3 className="text-sm font-default font-medium uppercase text-foreground tracking-wider max-w-[200px] mx-auto leading-snug">
                {pillar.subText}
              </h3>
            </div>)}
        </div>
      </div>
    </section>;
}